import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector';

import cn from './locales/zh.json'
import en from './locales/en.json'
import cs from './locales/cs.json'
import it from './locales/it.json'
import de from './locales/de.json'
import ja from './locales/ja.json'
import vi from './locales/vi.json'
import pt from './locales/pt.json'
import fr from './locales/fr.json'
import ko from './locales/ko.json'
import pl from './locales/pl.json'
import es from './locales/es.json'

const resources = {
  cn: { translation: cn },
  en: { translation: en },
  cs: { translation: cs },
  it: { translation: it },
  de: { translation: de },
  ja: { translation: ja },
  vi: { translation: vi },
  pt: { translation: pt },
  fr: { translation: fr },
  ko: { translation: ko },
  pl: { translation: pl },
  es: { translation: es },
}
// i18n.use(LanguageDetector) //嗅探当前浏览器语言 zh-CN
i18n
  .use(initReactI18next) // 将 i18n 向下传递给 react-i18next
  .init({
    //初始化
    resources, //本地多语言数据
    //  @ts-ignore
    fallbackLng: navigator?.browserLanguage || navigator.language || 'en', //默认当前环境的语言
    // fallbackLng: "fr-FR", //默认当前环境的语言
    detection: {
      caches: ['localStorage', 'sessionStorage', 'cookie'],
    },
  })

export default i18n
